import type { CreditPassSummary } from '../../types';
import { Spinner } from '../Spinner';
import styles from '../BookingWidget.module.css';

interface RedeemPassStepProps {
  passes: CreditPassSummary[];
  selectedId: string | null;
  isLoading: boolean;
  error: string | null;
  onSelect: (pass: CreditPassSummary) => void;
}

function formatValidUntil(value: string | null): string {
  if (!value) return 'Unbegrenzt gültig';
  return `Gültig bis ${new Intl.DateTimeFormat('de-CH', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(new Date(value))}`;
}

export function RedeemPassStep({
  passes,
  selectedId,
  isLoading,
  error,
  onSelect,
}: RedeemPassStepProps) {
  if (isLoading) {
    return <Spinner centered large />;
  }

  if (error) {
    return <p className={styles.error}>{error}</p>;
  }

  if (passes.length === 0) {
    return (
      <p className={styles.empty}>
        Kein aktives Guthaben gefunden. Bitte prüfe deine E-Mail oder kaufe ein neues
        Angebot.
      </p>
    );
  }

  return (
    <div className={styles.list}>
      {passes.map((pass) => (
        <button
          key={pass.id}
          type="button"
          className={selectedId === pass.id ? styles.cardSelected : styles.card}
          onClick={() => onSelect(pass)}
        >
          <p className={styles.cardTitle}>{pass.productName}</p>
          <p className={styles.cardMeta}>{formatValidUntil(pass.validUntil)}</p>
          <p className={styles.cardPrice}>
            {pass.creditsRemaining} von {pass.creditsTotal} Credits übrig
          </p>
        </button>
      ))}
    </div>
  );
}
